import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { SectorRole, SECTORS_PATHS } from '../../sectors';
import { Enums } from '../../../../configs/Enums';
import { sectorRoleOptions } from '../../constants/sector-role-options';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-sectors-list',
  templateUrl: './sectors-list.component.html',
  styleUrls: ['./sectors-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SectorsListComponent {
  public SECTORS_PATHS = SECTORS_PATHS;
  public Enums = Enums;

  @Input() filter;
  @Input() data;
  @Input() paginationBlock;
  @Input() tableBlock;

  formatSectorRole(sectorRole: SectorRole) {
    return sectorRoleOptions.find((item) => item.value === sectorRole).name;
  }

  onChangePlot(event, plot) {
    event.target.checked = plot.is_visible;

    this.tableBlock.onChangeStatePlot(plot);
  }

  onChangeSorting(sortData): void {
    this.filter.onChangeSorting(sortData);
  }
}
